(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-with-carousel-thebox-v3"] && !window.DesignMode) return;
  try {
    
      function initSlider() {
    var $sliderSelector = $('.slider-thebox');
    var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

	if (!$sliderSelector.length) {
		return false;	
	}

    /* Slider settings */
    var settings = {
      accessibility: true,
      arrows: false,
      dots: false,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [{
        breakpoint: 767,
        settings: "unslick"
      }]
    }

    // data options
    settings.autoplay = $sliderSelector.data('autorotate');
    settings.autoplaySpeed = $sliderSelector.data('speed');

    var adaptHeight = $sliderSelector.data('adapt-height');
    var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
    var sideArrows = $sliderSelector.data('side-arrows');

    if (adaptHeight) {
      $sliderSelector.height($(document).width() / minAspectRatio);
      $(window).resize($.debounce(50, function() {
        $sliderSelector.height($(document).width() / minAspectRatio);
      }));
    }

    var slider = $sliderSelector.slick(settings);

    var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
    var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

    if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
      if ($prevArrow && $prevArrow.length) {
        $prevArrow.on('click', function() {
          $sliderSelector.slick('slickPrev');
        });
      }
      if ($nextArrow && $nextArrow.length) {
        $nextArrow.on('click', function() {
          $sliderSelector.slick('slickNext');
        });
      }
    }

    /* Do this every time window gets resized */
    $(window).on('resize', function() {
      if ($(window).width() < 767) {
      /* We are below mobile breakpoint, initialize the slider
        if it is not already initialized */
      if (!slider.hasClass('slick-initialized')){
          return slider.slick(settings);
        }
      }
    })
  }
                                  
  initSlider();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["columns-list-slider-thebox"] && !window.DesignMode) return;
  try {
    

  var $sliderSelector = $('.slider-thebox');
  var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper')

  /* Slider settings */
  var settings = {
    accessibility: true,
    arrows: false,
    dots: false,
    fade: true,
    draggable: true,
    touchThreshold: 20,
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [{
      breakpoint: 767,
      settings: "unslick"
    }]
  }

  // data options
  settings.autoplay = $sliderSelector.data('autorotate');
  settings.autoplaySpeed = $sliderSelector.data('speed');

  var adaptHeight = $sliderSelector.data('adapt-height');
  var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
  var sideArrows = $sliderSelector.data('side-arrows');
  
  if (adaptHeight) {
    $sliderSelector.height($(document).width() / minAspectRatio);
    $(window).resize($.debounce(50, function() {
      $sliderSelector.height($(document).width() / minAspectRatio);
    }));
  }
  
  var slider = $sliderSelector.slick(settings);

  var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
  var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

  if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
    if ($prevArrow && $prevArrow.length) {
      $prevArrow.on('click', function() {
        $sliderSelector.slick('slickPrev');
      });
    }
    if ($nextArrow && $nextArrow.length) {
      $nextArrow.on('click', function() {
        $sliderSelector.slick('slickNext');
      });
    }
  }

  /* Do this every time window gets resized */
  $(window).on('resize', function() {
    if ($(window).width() < 767) {
    /* We are below mobile breakpoint, initialize the slider
      if it is not already initialized */
    if (!slider.hasClass('slick-initialized')){
        return slider.slick(settings);
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-bar-tbx-navidad"] && !window.DesignMode) return;
  try {
    

function initSlider() {
  var $sliderSelector = $('.slider-thebox');
  var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

if (!$sliderSelector.length) {
  return false;	
}

  /* Slider settings */
  var settings = {
    accessibility: true,
    arrows: false,
    dots: false,
    fade: true,
    draggable: true,
    touchThreshold: 20,
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [{
      breakpoint: 767,
      settings: "unslick"
    }]
  }

  // data options
  settings.autoplay = $sliderSelector.data('autorotate');
  settings.autoplaySpeed = $sliderSelector.data('speed');

  var adaptHeight = $sliderSelector.data('adapt-height');
  var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
  var sideArrows = $sliderSelector.data('side-arrows');

  if (adaptHeight) {
    $sliderSelector.height($(document).width() / minAspectRatio);
    $(window).resize($.debounce(50, function() {
      $sliderSelector.height($(document).width() / minAspectRatio);
    }));
  }

  var slider = $sliderSelector.slick(settings);

  var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
  var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

  if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
    if ($prevArrow && $prevArrow.length) {
      $prevArrow.on('click', function() {
        $sliderSelector.slick('slickPrev');
      });
    }
    if ($nextArrow && $nextArrow.length) {
      $nextArrow.on('click', function() {
        $sliderSelector.slick('slickNext');
      });
    }
  }

  /* Do this every time window gets resized */
  $(window).on('resize', function() {
    if ($(window).width() < 767) {
    /* We are below mobile breakpoint, initialize the slider
      if it is not already initialized */
    if (!slider.hasClass('slick-initialized')){
        return slider.slick(settings);
      }
    }
  })
}
                                
initSlider();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-bar-thebox-3"] && !window.DesignMode) return;
  try {
    

function initSlider() {
  var $sliderSelector = $('.slider-thebox');
  var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

if (!$sliderSelector.length) {
  return false;	
}

  /* Slider settings */
  var settings = {
    accessibility: true,
    arrows: false,
    dots: false,
    fade: true,
    draggable: true,
    touchThreshold: 20,
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [{
      breakpoint: 767,
      settings: "unslick"
    }]
  }

  // data options
  settings.autoplay = $sliderSelector.data('autorotate');
  settings.autoplaySpeed = $sliderSelector.data('speed');

  var adaptHeight = $sliderSelector.data('adapt-height');
  var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
  var sideArrows = $sliderSelector.data('side-arrows');

  if (adaptHeight) {
    $sliderSelector.height($(document).width() / minAspectRatio);
    $(window).resize($.debounce(50, function() {
      $sliderSelector.height($(document).width() / minAspectRatio);
    }));
  }

  var slider = $sliderSelector.slick(settings);

  var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
  var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

  if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
    if ($prevArrow && $prevArrow.length) {
      $prevArrow.on('click', function() {
        $sliderSelector.slick('slickPrev');
      });
    }
    if ($nextArrow && $nextArrow.length) {
      $nextArrow.on('click', function() {
        $sliderSelector.slick('slickNext');
      });
    }
  }

  /* Do this every time window gets resized */
  $(window).on('resize', function() {
    if ($(window).width() < 767) {
    /* We are below mobile breakpoint, initialize the slider
      if it is not already initialized */
    if (!slider.hasClass('slick-initialized')){
        return slider.slick(settings);
      }
    }
  })
}
                                
initSlider();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-bar-thebox"] && !window.DesignMode) return;
  try {
    

function initSlider() {
  var $sliderSelector = $('.slider-thebox');
  var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

if (!$sliderSelector.length) {
  return false;	
}

  /* Slider settings */
  var settings = {
    accessibility: true,
    arrows: false,
    dots: false,
    fade: true,
    draggable: true,
    touchThreshold: 20,
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [{
      breakpoint: 767,
      settings: "unslick"
    }]
  }

  // data options
  settings.autoplay = $sliderSelector.data('autorotate');
  settings.autoplaySpeed = $sliderSelector.data('speed');

  var adaptHeight = $sliderSelector.data('adapt-height');
  var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
  var sideArrows = $sliderSelector.data('side-arrows');

  if (adaptHeight) {
    $sliderSelector.height($(document).width() / minAspectRatio);
    $(window).resize($.debounce(50, function() {
      $sliderSelector.height($(document).width() / minAspectRatio);
    }));
  }

  var slider = $sliderSelector.slick(settings);

  var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
  var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

  if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
    if ($prevArrow && $prevArrow.length) {
      $prevArrow.on('click', function() {
        $sliderSelector.slick('slickPrev');
      });
    }
    if ($nextArrow && $nextArrow.length) {
      $nextArrow.on('click', function() {
        $sliderSelector.slick('slickNext');
      });
    }
  }

  /* Do this every time window gets resized */
  $(window).on('resize', function() {
    if ($(window).width() < 767) {
    /* We are below mobile breakpoint, initialize the slider
      if it is not already initialized */
    if (!slider.hasClass('slick-initialized')){
        return slider.slick(settings);
      }
    }
  })
}
                                
initSlider();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-bar-tbx-v2-home"] && !window.DesignMode) return;
  try {
    
      function initSlider() {
    var $sliderSelector = $('.slider-thebox');
    var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

	if (!$sliderSelector.length) {
		return false;	
	}

    /* Slider settings */
    var settings = {
      accessibility: true,
      arrows: false,
      dots: false,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [{
        breakpoint: 767,
        settings: "unslick"
      }]
    }

    // data options
    settings.autoplay = $sliderSelector.data('autorotate');
    settings.autoplaySpeed = $sliderSelector.data('speed');

    var adaptHeight = $sliderSelector.data('adapt-height');
    var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
    var sideArrows = $sliderSelector.data('side-arrows');

    if (adaptHeight) {
      $sliderSelector.height($(document).width() / minAspectRatio);
      $(window).resize($.debounce(50, function() {
        $sliderSelector.height($(document).width() / minAspectRatio);
      }));
    }

    var slider = $sliderSelector.slick(settings);

    var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
    var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

    if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
      if ($prevArrow && $prevArrow.length) {
        $prevArrow.on('click', function() {
          $sliderSelector.slick('slickPrev');
        });
      }
      if ($nextArrow && $nextArrow.length) {
        $nextArrow.on('click', function() {
          $sliderSelector.slick('slickNext');
        });
      }
    }

    /* Do this every time window gets resized */
    $(window).on('resize', function() {
      if ($(window).width() < 767) {
      /* We are below mobile breakpoint, initialize the slider
        if it is not already initialized */
      if (!slider.hasClass('slick-initialized')){
          return slider.slick(settings);
        }
      }
    })
  }
                                  
  initSlider();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navidad-compra-por-precio-imgbv2"] && !window.DesignMode) return;
  try {
    

function initSlider() {
  var $sliderSelector = $('.slider-thebox');
  var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

if (!$sliderSelector.length) {
  return false;	
}

  /* Slider settings */
  var settings = {
    accessibility: true,
    arrows: false,
    dots: false,
    fade: true,
    draggable: true,
    touchThreshold: 20,
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [{
      breakpoint: 767,
      settings: "unslick"
    }]
  }

  // data options
  settings.autoplay = $sliderSelector.data('autorotate');
  settings.autoplaySpeed = $sliderSelector.data('speed');

  var adaptHeight = $sliderSelector.data('adapt-height');
  var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
  var sideArrows = $sliderSelector.data('side-arrows');

  if (adaptHeight) {
    $sliderSelector.height($(document).width() / minAspectRatio);
    $(window).resize($.debounce(50, function() {
      $sliderSelector.height($(document).width() / minAspectRatio);
    }));
  }

  var slider = $sliderSelector.slick(settings);

  var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
  var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

  if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
    if ($prevArrow && $prevArrow.length) {
      $prevArrow.on('click', function() {
        $sliderSelector.slick('slickPrev');
      });
    }
    if ($nextArrow && $nextArrow.length) {
      $nextArrow.on('click', function() {
        $sliderSelector.slick('slickNext');
      });
    }
  }

  /* Do this every time window gets resized */
  $(window).on('resize', function() {
    if ($(window).width() < 767) {
    /* We are below mobile breakpoint, initialize the slider
      if it is not already initialized */
    if (!slider.hasClass('slick-initialized')){
        return slider.slick(settings);
      }
    }
  })
}
                                
initSlider();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-carousel"] && !window.DesignMode) return;
  try {
    

$(document).ready(function() {

  function initSlider() {
	
	var $carousel = $('.owl-carousel').owlCarousel({
        stagePadding: 60,
        loop:true,
        margin:10,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:4
            },
            1000:{
                items:6
            }
        }
    })

	var longestHeightTitle = 0;
    var biggestImage = 0
    //Reduce font-size based on lines

    //Retrieve the biggest title
    $(".products-carousel-thebox-wrapper .grid-view-item .grid-view-item__title").each(function(index){
      if($(this).height() > longestHeightTitle){
        longestHeightTitle = $(this).height()      
      }
    })
    //Retrieve the biggest image
    $(".products-carousel-thebox-wrapper .grid-view-item .grid-view-item__image-wrapper").each(function(index){
      if($(this).height() > biggestImage){
        biggestImage = $(this).height();      
      }
    })
    //Set equal height
    $(".products-carousel-thebox-wrapper .grid-view-item .grid-view-item__title").css({
      height: longestHeightTitle,
      display: 'block'
    }) 

    $(".products-carousel-thebox-wrapper .grid-view-item .grid-view-item__image-wrapper").css({
      height: biggestImage,
      maxHeight: 'initial',
      paddingTop: '0px'
    }) 
    $(".products-carousel-thebox-wrapper .grid-view-item .grid-view-item__image-wrapper div").css({
      height: biggestImage,
      paddingTop: '0px'
    }) 
    $(".products-carousel-thebox-wrapper .grid-view-item .grid-view-item__image-wrapper img").css({
      height: biggestImage,
      objectFit: 'contain'
    })

  }

  initSlider();

  $(document).on('shopify:section:load', function(){ 
	initSlider();
  });

})


  } catch(e) { console.error(e); }
})();
})();
